/**
 * The window the scene's avatar shows through. The module itself is transparent; it only says, in
 * words, what the voice is doing — for whoever cannot hear it.
 */
import { useTranslate } from '../../react/hooks';
import { useVoice } from '../../voice/useVoice';
import { Icon } from '../../ui-kit/Icon';
import css from './AvatarWindow.module.css';

const LABEL: Record<string, { key: string; icon: string } | undefined> = {
  listening: { key: 'voice.listening', icon: 'ear' },
  processing: { key: 'voice.processing', icon: 'sparkles' },
  speaking: { key: 'voice.speaking', icon: 'assistant' },
  interrupted: { key: 'voice.interrupted', icon: 'stop' },
};

export function AvatarWindowModule() {
  const t = useTranslate();
  const activity = useVoice((v) => v.activity);
  const label = LABEL[activity];
  return (
    <div className={css.window}>
      {label && (
        <span className={`${css.badge} ${css[activity]}`} role="status">
          <Icon name={label.icon} size={24} />
          {t(label.key)}
        </span>
      )}
    </div>
  );
}
